import React, { useState } from 'react';

const ActualCheckInStats = ({ actualStats, className = "" }) => {
  const [showModal, setShowModal] = useState(false);

  if (!actualStats) return null;

  const explanations = [
    {
      title: "RSVP'd & Attended",
      description: "People who RSVP'd and actually attended the event",
      color: "text-green-600",
      icon: "✅"
    },
    {
      title: "No Show", 
      description: "People who RSVP'd but didn't show up to the event",
      color: "text-red-600",
      icon: "❌"
    },
    {
      title: "Walk-in",
      description: "People who attended without RSVP'ing (walk-in attendees)",
      color: "text-blue-600", 
      icon: "🚶‍♂️"
    },
    {
      title: "Total Attended",
      description: "Total number of people who actually attended (RSVP'd + Walk-ins)",
      color: "text-indigo-600",
      icon: "👥"
    }
  ];

  return (
    <div className={`bg-gray-50 p-4 sm:p-6 rounded-lg ${className}`}>
      <h3 className="text-lg font-semibold mb-4 flex items-center justify-between">
        <div className="flex items-center">
          <span className="mr-2">✅</span>
          Actual Check-in Statistics
        </div>
        <button
          onClick={() => setShowModal(true)}
          className="text-gray-400 hover:text-gray-600 text-sm"
          title="View explanations"
        >
          ℹ️
        </button>
      </h3>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        <div className="text-center">
          <div className="text-xl sm:text-2xl font-bold text-green-600">{actualStats.rsvpAndAttended || 0}</div>
          <div className="text-sm text-gray-600">RSVP'd & Attended</div>
        </div>
        <div className="text-center">
          <div className="text-xl sm:text-2xl font-bold text-red-600">{actualStats.noShow || 0}</div>
          <div className="text-sm text-gray-600">No Show</div>
        </div>
        <div className="text-center">
          <div className="text-xl sm:text-2xl font-bold text-blue-600">{actualStats.walkIn || 0}</div>
          <div className="text-sm text-gray-600">Walk-in</div>
        </div>
        <div className="text-center">
          <div className="text-xl sm:text-2xl font-bold text-indigo-600">{actualStats.actualAttended || 0}</div>
          <div className="text-sm text-gray-600">Total Attended</div>
        </div>
      </div>
      <div className="mt-4 pt-4 border-t border-gray-200">
        <div className="bg-white p-3 rounded-lg border border-gray-200 text-center">
          <div className="text-sm text-gray-600">
            Attendance Rate: <span className="font-bold text-blue-600">
              {actualStats.attendanceRate ? actualStats.attendanceRate.toFixed(1) : 0}%
            </span>
          </div>
          <div className="text-xs text-gray-500 mt-1">
            ({actualStats.rsvpAndAttended || 0} out of {actualStats.totalRsvp || 0} RSVP'd)
          </div>
        </div>
      </div>

      {/* Explanation Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full max-h-[80vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold text-gray-900">Check-in Statistics Explained</h3>
                <button
                  onClick={() => setShowModal(false)}
                  className="text-gray-400 hover:text-gray-600 text-xl"
                >
                  ×
                </button>
              </div>
              
              <div className="space-y-4">
                {explanations.map((item, index) => (
                  <div key={index} className="flex items-start space-x-3 p-3 bg-gray-50 rounded-lg">
                    <span className="text-2xl">{item.icon}</span>
                    <div>
                      <h4 className={`font-semibold ${item.color}`}>{item.title}</h4>
                      <p className="text-sm text-gray-600 mt-1">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="mt-6 pt-4 border-t border-gray-200">
                <p className="text-xs text-gray-500 text-center">
                  These statistics help track actual event attendance vs. RSVP commitments.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ActualCheckInStats;
